module.exports = __webpack_public_path__ + "res/13-img_game_bg_r.69c94718b1a664f733a6a08d82d71972.webp";